import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6290afa1&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6290afa1')) {
      api.createRecord('6290afa1', component.options)
    } else {
      api.reload('6290afa1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6290afa1&", function () {
      api.rerender('6290afa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ads/task/index.vue"
export default component.exports